<script setup lang="ts">
import { useRouter } from "vue-router";
import { Metadata } from "@/models/Metadata";
defineProps<{
  brand: string;
  casename: string;
  casefile?: string;
  file: Metadata;
}>();

const $router = useRouter();
function back(): void {
  $router.back();
}
</script>
<template>
  <div v-show="casefile === file.fileReference">
    <nav class="tw-sticky tw-top-0 tw-z-10 tw-flex tw-items-center tw-bg-gray-900 tw-px-3 tw-py-1">
      <a class="tw-py-1 tw-text-white" href="#" @click.prevent>
        <button type="button" class="tw-btn-md-white tw-b-r tw-mr-1" title="Back" @click.prevent="back">
          <i class="fas fa-arrow-left"></i>
        </button>
        Attempted to view contents of:
        <strong>{{ file.displayName }}</strong>
      </a>
    </nav>
    <div class="tw-bg-gray-100" style="margin: 1rem 2rem; padding: 2rem">
      <h2>This file is of an unknown type and cannot be viewed within RS Docs.</h2>
      <p>Please use the properties pane if you would like to make notes or manage metadata for this file.</p>
    </div>
  </div>
</template>
